<template>
	<!-- Card -->
	<div class="card">
		<div class="card-body">

			<!-- Media -->
			<div v-if="isEmbeddableImage">
				<div class="mb-3 bg-secondary rounded ratio ratio-1x1">
					<div class="w-100 h-100">

						<img :src="media.embeddable.url"
							:class="media.embeddable.width >= media.embeddable.height
								? 'position-absolute w-100 h-auto top-50 start-50 translate-middle'
								: 'position-absolute h-100 w-auto top-50 start-50 translate-middle'"
							id="media">
					</div>
				</div>
			</div>

			<div v-else-if="isEmbeddableVideo && media.poster">
				<div class="mb-3 bg-secondary rounded ratio ratio-1x1">

						<video controls :poster="media.poster.url"
							style="object-fit:contain;"
							:class="media.embeddable.width >= media.embeddable.height
									? 'position-absolute w-100 h-auto top-50 start-50 translate-middle'
									: 'position-absolute h-100 w-auto top-50 start-50 translate-middle'">
							<source :src="media.embeddable.url" type="video/mp4">
							Your browser does not support the video tag.
						</video>

				</div>
			</div>

			<div v-else-if="isEmbeddableVideo && !media.poster">
				<div class="mb-3 text-center ratio ratio-1x1 bg-secondary rounded">

						<video controls
							style="object-fit:contain;"
							:class="media.embeddable.width >= media.embeddable.height
									? 'w-100 h-auto top-50 start-50 translate-middle'
									: 'h-100 w-auto top-50 start-50 translate-middle'">
							<source :src="media.embeddable.url" type="video/mp4">
							Your browser does not support the video tag.
						</video>

				</div>
			</div>

			<div v-else-if="media.aggregate_type == 'audio'">
				<div class="mb-3 text-center ratio ratio-1x1 bg-secondary rounded">
					<div class="d-flex flex-column align-items-center justify-content-center">
						<div class="text-white mb-3"><i class="fe fe-music"></i></div>
						<div class="fw-bold text-white">Audio</div>
					</div>
				</div>
			</div>

			<div v-else-if="media.processing_job_status == 'failed'">
				<div class="mb-3 text-center ratio ratio-1x1 bg-secondary rounded">
					<div class="d-flex flex-column align-items-center justify-content-center">
						<div class="text-white mb-3"><i class="fe fe-eye-off"></i></div>
						<div class="fw-bold text-white">Could not create embeddable media</div>
					</div>
				</div>
			</div>

			<div v-else>
				<div class="mb-3 text-center ratio ratio-1x1 bg-secondary rounded">
					<div class="d-flex flex-column align-items-center justify-content-center">
						<div class="spinner-border text-white mb-3" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
						<div class="fw-bold text-white">Processing media...</div>
						<div class="small text-light mt-2">
							You do not need to keep this window open while the process completes.
						</div>
					</div>
				</div>
			</div>

		</div>
	</div><!--/.card-->
</template>

<script>
	import dayjs from 'dayjs';

	export default {

		props: ['mediaData', 'mediaEndpoint'],

		data() {
			return {
				media: this.mediaData,
				polling: null,
				isLoaded: false,
				files: [],
			}
		},

		mounted() {

			this.resetPolling();

		},

		computed: {

			isEmbeddableVideo() {
				if(this.media.aggregate_type == 'video' && this.media.embeddable) {
					return true;
				}
				return false;
			},

			isEmbeddableImage() {
				if(this.media.aggregate_type == 'image' && this.media.embeddable) {
					return true;
				}
				return false;
			},

		},

		methods: {

			fetchMedia() {
				axios.get(this.mediaEndpoint +  '/' + this.media.id)
					.then((response) => {

						this.media = response.data;

						if(this.isEmbeddableImage || this.isEmbeddableVideo) {
							clearInterval(this.polling); // won't be polled anymore
						}
					})
					.catch((error) => {
						console.error(error);
					});
			},

			resetPolling() {
				clearInterval(this.polling);
				if(!this.media.embeddable && this.media.processing_job_status != 'failed') {
					this.polling = setInterval(() => {
						this.fetchMedia()
					}, 3000) // check every 3 seconds
					setTimeout(() => { clearInterval(this.polling) }, 1000 * 60 * 30) //stop polling after 30 minutes
				}
			},

			formatDate(date) {
				return dayjs(date).format('MMM D, YYYY h:mma');
			},

			formatBytes(bytes, decimals = 0) {
				if (bytes === 0) return '0 bytes';
				const k = 1024;
				const dm = decimals < 0 ? 0 : decimals;
				const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
				const i = Math.floor(Math.log(bytes) / Math.log(k));
				return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
			},

			isLowRes(width, height) {
				if(width > 0 && height > 0 && (width * height < 1920 * 1080)) {
					return true;
				}
				else {
					return false;
				}
			},

			nl2br(str, is_xhtml) {
				var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />'   : '<br>';
				return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag   + '$2');
			}

		},

		beforeDestroy () {
			clearInterval(this.polling);
		}
	}

</script>
